import classNames from 'classnames';
import Image from 'next/image';
import { FC } from 'react';

import type { ArticleOnce } from '@/entities/article';
import ArticleDownload from '@/widgets/article/ui/ArticleDownload/ArticleDownload';

import styles from './articleOnceSubHead.module.scss';

interface ArticleOnceSubHeadProps {
  value: ArticleOnce;
}

const ArticleOnceSubHead: FC<ArticleOnceSubHeadProps> = (props) => {
  const { value } = props;
  return (
    <section className={styles.section}>
      <div className={classNames('is-desk', styles.section__itemLeft)}>
        <ArticleDownload value={value} />
      </div>
      <div className={styles.section__itemRight}>
        <div className={styles.section__row}>
          <div className={styles.section__textBlock}>
            {value.description?.trim() ? (
              <p className={styles.section__text}>{value.description}</p>
            ) : null}
          </div>
        </div>
        <div className={classNames('is-mob', styles.section__download)}>
          <ArticleDownload value={value} />
        </div>
        <div className={styles.section__imageBlock}>
          <Image
            alt={value.name}
            className={styles.section__image}
            height={638}
            src={value.image}
            width={944}
          />
        </div>
      </div>
    </section>
  );
};

export default ArticleOnceSubHead;
